export const FIELD_VALUE_UPDATED = 'ui2-field-value-updated'
export const SORT_SELECTED = 'ui2-sort-selector-selected'
export const SORT_ORDER_CHANGED = 'ui2-sort-selector-sort-order'
export const RETRY_IMAGE_UPLOAD = "retry_image_upload"
export const RETRY_ALL_IMAGE_UPLOAD = "retry_all_image_upload"
export const CANCEL_IMAGE_UPLOAD = "cancel_image_upload"
export const CANCEL_ALL_IMAGE_UPLOAD = "cancel_all_image_upload"

export const BASIC_ITEM_CARD_TITLE_CLICKED = 'basic-item-card-title-clicked'

export const RETRY_ONE_SELECT_ITEM = 'retry-one'
export const CANCEL_ONE_SELECT_ITEM = 'cancel-one'
export const RETRY_ALL_SELECT_ITEM = 'retry-all'
export const CANCEL_ALL_SELECT_ITEM = 'cancel-all'